import React, { useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import WidgetsRender from "@widgets/render-engine";
import WidgetsContext from "@stores/widgets-context";
import Layout from "@widgets/layout";
import { GetWidgetResponse } from "@helpers/fetch-json";
import LoadingScreen from "./loading-screens";

const WidgetInLocation = ({ widgets, location }) => {
    const shouldRender =
        (widgets &&
            widgets.filter((x) => x.data.renderLocation === location).length) >
        0;
    return shouldRender && <WidgetsRender data={widgets} location={location} />;
};

const WidgetPage = (props) => {
    const cxt = useContext(WidgetsContext);
    const routeParams = useParams();

    const { id } = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        if (props.path) {
            if (
                cxt.preLoadedWidgets != null &&
                cxt.preLoadedWidgets.path == props.path
            ) {
                cxt.setWidgets(cx.preLoadedWidgets.data);
                return;
            }

            GetWidgetResponse(
                props.path,
                routeParams,
                props.requestMethod,
                props.requestBody
            )
                .then((widgets) => {
                    setLoading(false);
                    cxt.setWidgets(widgets);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                });
        }
    }, [id, props.path]);

    const mainWidget = useMemo(
        () => <WidgetsRender data={cxt.widgets} location="main" />,
        [cxt.widgets]
    );

    const bottomWidget = useMemo(
        () =>
            // Use widget in location as a method call (instead of widget),
            // as we need to know whether it is null in Layout.
            // If we pass through the 'tag' version, i.e. <WidgetInLocation ... />
            // the react element is never null (i.e. it is not 'evaluated' to null)
            WidgetInLocation({ widgets: cxt.widgets, location: "bottom" }),
        [cxt.widgets]
    );

    const bottomStickyWidget = useMemo(
        () =>
            WidgetInLocation({
                widgets: cxt.widgets,
                location: "sticky-bottom",
            }),
        [cxt.widgets]
    );

    const topStickyWidget = useMemo(
        () =>
            WidgetInLocation({
                widgets: cxt.widgets,
                location: "sticky-top",
            }),
        [cxt.widgets]
    );

    const topWidgets = useMemo(
        () => <WidgetsRender data={cxt.widgets} location="top" />,
        [cxt.widgets]
    );

    const rightWidget = useMemo(
        () => <WidgetsRender data={cxt.widgets} location="right" />,
        [cxt.widgets]
    );

    const loadingScreenVm = props.loadingScreenVm ?? {};

    const hasRightWidget = cxt.widgets?.find(
        (x) => x.data?.renderLocation === 'right'
    );

    return loading ? (
        <LoadingScreen {...loadingScreenVm} />
    ) : (
        <Layout
            stickyTop={topStickyWidget}
            right={hasRightWidget ? rightWidget : null}
            main={mainWidget}
            top={topWidgets}
            bottom={bottomWidget}
            stickyBottom={bottomStickyWidget}
        />
    );
};

export default WidgetPage;
